import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import ReCAPTCHA from 'react-google-recaptcha'

const useRecaptcha = ({ siteKey, enabled, success, onUnavailable }) => {
  const [ token, setToken ] = useState(null)
  const root = useRef()
  const ref = useRef()
  const available = enabled && !token

  useEffect(() => { if (token) success(token) }, [ token ])

  const renderElement = () => {
    if (!enabled) return
    if (!root.current) {
      root.current = document.createElement('div')
      root.current.className = 'visually-hidden'
      document.body.appendChild(root.current)
    }

    return createPortal(
      <ReCAPTCHA
        ref={ref}
        size="invisible"
        sitekey={siteKey}
        onChange={setToken}
        onErrored={() => onUnavailable?.()}
        onExpired={() => onUnavailable?.()}
      />,
      root.current
    )
  }

  const execute = () => ref.current.execute()

  const reset = () => {
    setToken(null)
    ref.current?.reset()
  }

  return { available, renderElement, execute, reset }
}

export default useRecaptcha
